(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header');
    const headerWrapper = headerElement?.querySelector('.header_wrapper');

    if (!headerElement || !headerWrapper) return;

    document.documentElement.style.setProperty('--header-height', headerElement.clientHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerWrapper.clientHeight + 'px');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jasport-halloween-atmosphere"]) return;
  try {
    
  if (!customElements.get('jasport-halloween-atmosphere')) {
    customElements.define('jasport-halloween-atmosphere', class extends HTMLElement {
      connectedCallback() {
        if (this.motionQuery) return;
        this.layer = this.querySelector('[data-halloween-particles]');
        this.toggle = this.querySelector('[data-halloween-toggle]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.paused = false;
        this.userEnabled = false;
        try {
          this.paused = sessionStorage.getItem('jasportHalloweenPaused') === 'true';
          this.userEnabled = sessionStorage.getItem('jasportHalloweenMotionEnabled') === 'true';
        } catch {}
        this.onVisibility = () => this.syncPause();
        this.onPreference = () => this.renderParticles();
        this.onToggle = () => {
          if (this.motionQuery.matches && !this.userEnabled) {
            this.userEnabled = true;
            this.paused = false;
            try { sessionStorage.setItem('jasportHalloweenMotionEnabled', 'true'); } catch {}
            this.renderParticles();
            return;
          }
          this.paused = !this.paused;
          try { sessionStorage.setItem('jasportHalloweenPaused', String(this.paused)); } catch {}
          this.syncPause();
        };
        this.toggle.addEventListener('click', this.onToggle);
        this.motionQuery.addEventListener('change', this.onPreference);
        this.mobileQuery.addEventListener('change', this.onPreference);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.renderParticles();
      }

      renderParticles() {
        this.layer.replaceChildren();
        this.hidden = false;
        this.dataset.motion = this.motionQuery.matches ? 'reduced' : 'running';
        this.toggleAttribute('data-user-enabled', this.userEnabled);
        if (this.motionQuery.matches && !this.userEnabled) {
          this.syncPause();
          return;
        }
        const mobile = this.mobileQuery.matches;
        const configuredCount = Math.max(4, Math.min(16, Number(this.dataset.count) || 10));
        const count = mobile ? Math.min(6, Math.ceil(configuredCount / 2)) : configuredCount;
        const baseSize = Math.max(18, Math.min(36, Number(this.dataset.size) || 28)) * (mobile ? .8 : 1);
        const shapes = ['pumpkin', 'pumpkin', 'ghost', 'pumpkin', 'bat', 'ghost', 'pumpkin', 'leaf'];
        const fragment = document.createDocumentFragment();
        for (let i = 0; i < count; i++) {
          const shape = shapes[i % shapes.length];
          const template = this.querySelector('[data-halloween-shape="' + shape + '"]');
          if (!template) continue;
          const fall = document.createElement('span');
          const piece = document.createElement('span');
          const duration = 17 + Math.random() * 10;
          const progress = (i / count + .27) % 1;
          fall.className = 'jha__fall';
          piece.className = 'jha__piece';
          fall.dataset.shape = shape;
          fall.style.setProperty('--jha-x', ((i + .25 + Math.random() * .5) / count * 100).toFixed(2) + '%');
          fall.style.setProperty('--jha-size', (baseSize * (.8 + Math.random() * .3)).toFixed(1) + 'px');
          fall.style.setProperty('--jha-duration', duration.toFixed(2) + 's');
          fall.style.setProperty('--jha-delay', (-duration * progress).toFixed(2) + 's');
          fall.style.setProperty('--jha-drift', ((Math.random() - .5) * (mobile ? 45 : 100)).toFixed(1) + 'px');
          fall.style.setProperty('--jha-angle', (Math.random() * 35 - 17.5).toFixed(1) + 'deg');
          fall.style.setProperty('--jha-spin', ((Math.random() - .5) * (shape === 'bat' ? 65 : 180)).toFixed(1) + 'deg');
          fall.style.setProperty('--jha-sway', (3 + Math.random() * 3).toFixed(2) + 's');
          fall.style.setProperty('--jha-opacity', (.35 + Math.random() * .2).toFixed(2));
          piece.append(template.content.cloneNode(true));
          fall.append(piece);
          fragment.append(fall);
        }
        this.layer.append(fragment);
        this.syncPause();
      }

      syncPause() {
        const paused = this.paused || this.motionQuery.matches && !this.userEnabled;
        this.toggleAttribute('data-paused', paused || document.hidden);
        this.toggleAttribute('data-user-paused', paused);
        const label = paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.setAttribute('title', label);
        this.toggle.setAttribute('aria-pressed', String(paused));
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        this.motionQuery?.removeEventListener('change', this.onPreference);
        this.mobileQuery?.removeEventListener('change', this.onPreference);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.motionQuery = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jasport-halloween-coupon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jasport-coupon')) {
    customElements.define('jasport-coupon', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const button = this.querySelector('button');
        const input = this.querySelector('input');
        const status = this.querySelector('[role="status"]');
        if (!button || !input || !status) return;
        button.hidden = false;
        button.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(input.value);
            status.textContent = button.dataset.copied;
          } catch {
            input.focus();
            input.select();
            status.textContent = button.dataset.manual;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yesoul-app-offer"] && !Shopify.designMode) return;
  try {
    
  function initYesoulAppOfferDialogs(scope = document) {
    const offers = scope.matches?.('[data-app-offer]') ? [scope] : scope.querySelectorAll('[data-app-offer]');
    offers.forEach((offer) => {
      if (offer.dataset.appOfferDialogReady === 'true') return;
      const triggers = offer.querySelectorAll('[data-app-offer-open]');
      const dialog = offer.querySelector('[data-app-offer-dialog]');
      const close = offer.querySelector('[data-app-offer-close]');
      const toggle = offer.querySelector('[data-app-offer-toggle]');
      const mobileDetails = offer.querySelector('[data-app-offer-mobile-details]');
      if (!triggers.length || !dialog || !close) return;
      offer.dataset.appOfferDialogReady = 'true';
      let opener;
      triggers.forEach((trigger) => trigger.addEventListener('click', () => {
        if (dialog.open) return;
        opener = trigger;
        dialog.showModal();
      }));
      toggle?.addEventListener('click', () => {
        if (!mobileDetails) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        mobileDetails.hidden = expanded;
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    });
  }
  initYesoulAppOfferDialogs();
  document.addEventListener('shopify:section:load', (event) => initYesoulAppOfferDialogs(event.target));

  } catch(e) { console.error(e); }
})();
})();
